import React from 'react';

export const BurgerMenuIcon = ({ color }) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.5 7.5H15" stroke={color} stroke-width="2" />
    <path d="M3.5 12.5H20.5" stroke={color} stroke-width="2" />
    <path d="M3.5 17.5H15" stroke={color} stroke-width="2" />
  </svg>
);
